import PROCESS_TYPES from './processes';
import getCommonData from './common';
import Logger from '../logger';
import { getProcessByTag } from './tags';

const tempArgsTransform = (args) => {
    if (args.contactProcessType === 'Diagnostic' && args.tags === 'onboarding') {
        args.contactProcessType = 'Support';
        args.tags = ['onboarding'];
    }
};

const getDefaultArgsValues = (args) => {
    if (!args.loginType) {
        args.loginType =
            window.WC._localStorage.get('userStatus') &&
            window.WC._localStorage.get('userStatus') === 'loggedIn'
                ? 'full'
                : 'none';
    }
    if (!args.contactProcessType) {
        if (args.diagnosticTags || args.diagnostics) {
            args.contactProcessType = 'Diagnostic';
        } else if (args.verMO && args.loginType?.toLowerCase() === 'full') {
            args.contactProcessType = 'Support';
        } else if (
            args.msisdn ||
            args.userIdentificationNumber ||
            args.customerType ||
            (args.verMO && args.loginType?.toLowerCase() === 'none')
        ) {
            args.contactProcessType = 'Registration';
        } else if (args.tags) {
            args.tags.some((t) => {
                const process = getProcessByTag(t);
                if (process) {
                    args.contactProcessType = process;
                    return true;
                }
            });
        }

        if (!args.contactProcessType) {
            args.contactProcessType = 'None';
        }
    }
    return args;
};

const getProcessTypeData = (args) => {
    tempArgsTransform(args);
    args = getDefaultArgsValues(args);

    const processData = PROCESS_TYPES[args.contactProcessType](args);
    Logger.log('processType ->', args.contactProcessType);

    const commonData = getCommonData(args);
    return {
        ...commonData,
        ...processData,
        additionalData: {
            ...commonData.additionalData,
            ...(processData.additionalData && {
                ...processData.additionalData
            }),
            ...(args.tags && {
                tags: args.tags.join(',')
            }),
            ...(processData.tags && {
                tags: processData.tags.join(',')
            })
        }
    };
};

export { getProcessTypeData };
